export const variants = {
  light: {
    hoverColor: 'border.light',
    checked: {
      background: 'background.checked',
      border: 'border.dark',
      text: 'text.primary',
      iconBackground: 'border.dark',
    },
    unchecked: {
      background: 'background.base',
      opacity: 0.2,
      border: 'border.dark',
      text: 'text.primary',
      iconBackground: 'border.dark',
    },
  },
  dark: {
    hoverColor: 'border.dark',
    checked: {
      background: 'hero.plum',
      border: 'border.dark',
      text: 'text.lightest',
      iconBackground: 'text.lightest',
    },
    unchecked: {
      background: 'hero.lilac',
      border: 'border.dark',
      text: 'hero.plum',
      iconBackground: 'border.dark',
    },
  },
};
